import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { normalizeEntityPath } from '../../utils/siteUrls';

export default function EntityUrlRedirect({ children, canonicalPath }) {
  const location = useLocation();
  const pathname = canonicalPath || normalizeEntityPath(location.pathname);
  return pathname === location.pathname ? children : (
    <Navigate replace to={{ pathname, search: location.search, hash: location.hash }} state={location.state} />
  );
}
